import { render, staticRenderFns } from "./RoleAddPage.vue?vue&type=template&id=3604606a&scoped=true&"
import script from "./RoleAddPage.vue?vue&type=script&lang=ts&"
export * from "./RoleAddPage.vue?vue&type=script&lang=ts&"
import style0 from "./RoleAddPage.vue?vue&type=style&index=0&id=3604606a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3604606a",
  null
  
)

export default component.exports